export default "<p>workflow-carousel works!</p>\r\n"